module.exports = __webpack_public_path__ + "img/notes-white.728e748a.svg";